import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Component } from "@angular/core";
import { IAuditWebServiceClient} from "@common/resources/resources";
import { CerbaCookieService, CorrespondantStore, UserStore, PopinCompteComponent, ProfilValideDto } from "@digicerba/common";
import { TranslateService } from "@ngx-translate/core";
import { AsiDialogService } from "@asi-ngtools/lib";
import {DetectBrowser} from "@common/browser/detect-browser";

@Component({
  selector: 'cerba',
  templateUrl: './cerba.component.html',
  host: {'class': 'flex'},
  providers: [AsiDialogService]
})
export class CerbaPageComponent {

  context: any;
  showAriane: boolean;

  constructor(private router: Router, private auditWebServiceClient: IAuditWebServiceClient,
              private correspondantStore: CorrespondantStore,
              private userStore: UserStore,
              private activatedRoute: ActivatedRoute,
              private cookieService: CerbaCookieService,
              private translate: TranslateService,
              public asiDialogService: AsiDialogService) {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.auditWebServiceClient.info({url: event.url}).subscribe(() => {
        });
      }
    });

    this.showAriane = true;
  }

  ngOnInit() {
    let tags: string[] = [];
    if (this.correspondantStore.getCorrespondant()) {
      tags = this.correspondantStore.getCorrespondant().tags;
    }

    let profilValideDto: ProfilValideDto = this.activatedRoute.snapshot.data['profilValide'];

    this.context = {
      user: this.userStore.getUser(),
      domain: this.cookieService.getDomain(window.location.hostname),
      supportBaseUrl: this.cookieService.getSupportBaseUrl(window.location.hostname),
      nbAlerts: this.activatedRoute.snapshot.data['nbAlerts'],
      // Ajout des tags pour la gestion dynamique des outils du header et footer
      tags: tags,
      // Ajout de la gestion de la validité des informations utilisateurs
      profilValide: profilValideDto,
      openPopin: this.openPopinCompte,
      component: this,
    };

    if(profilValideDto.autoDisplayPopin){
      this.openPopinCompte(this);
    }

    if (tags.indexOf("en") != -1 && tags.indexOf("fr") == -1) {
      this.translate.use('en');
    }
    else {
      this.translate.use('fr');
    }

    if(this.router && this.router.url){
      let baseUrl = this.router.parseUrl(this.router.url)
      if(baseUrl && baseUrl.queryParams && baseUrl.queryParams["showAriane"] === "false"){
        this.showAriane = false;
      }
    }
  }

  openPopinCompte(component: CerbaPageComponent): void{
    // let asiDialog = component.asiDialogService.fromComponent(PopinCompteComponent, null);
    // let profilValideDto: ProfilValideDto = component.activatedRoute.snapshot.data['profilValide'];
    // asiDialog.getComponent().formattedDate = profilValideDto.dateLimite;
  }

  checkIFrame() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  isShowAriane() {
    if(this.checkIFrame()){
      return this.showAriane;
    }
    return true;
  }

  isInternetExplorer(): boolean {
    return DetectBrowser.isInternetExplorer();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/cerba.component.ts